import { KeyboardEvent } from 'react';

import { isEnterKeyPress } from './event';

export const enterPress = (event: KeyboardEvent<HTMLInputElement>, action: () => void) => {
  if (isEnterKeyPress(event)) {
    action();
  }
};

export const preventEnter = (event: KeyboardEvent<HTMLInputElement>) => {
  if (isEnterKeyPress(event)) {
    event.preventDefault();
  }
};
